export default "__VITE_ASSET__BwEjLIyc__"